<template>
  <div class="wrap">
    <loading :active="loading" :z-index="1000"
             :is-full-page="false"/>

    <!-- Header -->
    <div class="px-2"
         v-show="!loading">
      <div class="target">
        <div class="text-left">
          <strong>IPCC 1.5°C 시나리오</strong>
        </div>
        <div class="text-left">
          IPCC 시나리오 중 에너지, 인간, 경제 등의 지속가능성에 초점을 둔 P2 시나리오를 기준으로 함
        </div>
      </div>
    </div>
    <!-- /Header -->

    <!-- Chart -->
    <esg-base-chart height="330px">
      <apex-chart ref="chart"
                  v-show="!loading"
                  type="line"
                  height="300"
                  :options="chartOptions"
                  :series="series"/>
    </esg-base-chart>
    <!-- /Chart -->

    <!-- Table -->
    <esg-table-without-meta :items="tableItems"
                            :fields="tableFields"
                            v-show="!loading"
                            size="xs"/>
    <!-- /Table -->
  </div>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: { EsgTableWithoutMeta, EsgBaseChart },
  data() {
    return {
      loading: false,
      series: [],
      ndcTarget: 0,
      firmwideTarget: 0,
      tableItems: [],
      tableFields: [{ name: 'item', label: '구분', list: true }],
      chartOptions: {
        chart: {
          fontFamily: 'NanumGothic, serif',
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        grid: {
          padding: {
            right: 60
          }
        },
        labels: [],
        xaxis: {
          type: 'datetime',
          crosshair: { show: false },
          tooltip: { enabled: false, },
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5,
          crosshair: { show: false },
          labels: {
            formatter: (val) => val + '%'
          }
        },
        tooltip: {
          x: {
            formatter: (val) => new Date(val).getFullYear()
          },
          y: {
            formatter: (val) => val + '%'
          }
        },
        dataLabels: {
          enabled: false,
          formatter: (val) => this.compactFormatNumber(val) + ' tCO2e'
        },
        markers: {
          size: 6,
          hover: { size: 6 }
        },
        stroke: {
          width: 3,
          curve: 'straight'
        },
        legend: {
          position: 'right',
        },
        responsive: [
          {
            breakpoint: 700,
            options: {
              legend: {
                position: 'bottom'
              },
              grid: {
                padding: {
                  right: 10
                }
              }
            }
          }
        ],
      },
    }
  },
  created() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let years = [2018, 2030, 2035, 2040, 2045, 2050];
        let args = [{ years }];

        let data = new FormData()
        data.append('path', 'esg/target/ipcc/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

                if (!response.data.data) {
          this.series = [];
          return;
        }
;
        let list = JSON.parse(response.data.data)[0].data;

        this.setSeries(list, years);
        this.setLabels(years);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
    setSeries(list, years) {
      let ipccTargets = [];
      let firmwideTargetsPercent = [];
      let firmwideTargetsAmount = [];

      years.forEach(year => {
        let row = list.find(row => row.year === year);
        ipccTargets.push(row ? row.ipcc_target : null);
        firmwideTargetsPercent.push(row ? row.firmwide_target_percent : null);
        firmwideTargetsAmount.push(row ? row.firmwide_target_amount : null);
      });

      this.series = [
        { name: '1.5°C-P2', data: ipccTargets },
        { name: '금호석유화학', data: firmwideTargetsPercent },
      ];

      // Table items
      this.tableItems = [
        { item: '1.5°C-P2' },
        { item: '목표 배출비율' },
        { item: '목표 배출량 (tCO2)' }
      ];
      years.forEach((year, idx) => {
        this.tableFields.push({
          name: `${year}`,
          label: year,
          list: true,
        });
        this.tableItems[0][year] = ipccTargets[idx] + '%';
        this.tableItems[1][year] = firmwideTargetsPercent[idx] + '%';
        this.tableItems[2][year] = this.formatNumber(firmwideTargetsAmount[idx], 0)
      });
    },
    setLabels(years) {
      this.chartOptions.labels = years.map(year => `01/01/${year}`);
    },
  }
}
</script>

<style scoped>
.wrap {
  width: 100%;
}

.target {
  font-size: 1rem;
}

>>> .table-wrapper {
  overflow-x: scroll;
  white-space: nowrap;
}

>>> .table-wrapper table {
  width: auto;
  min-width: 100%;
  margin-bottom: 0;
}

>>> .table td,
>>> .table th {
  font-size: .7rem;
  text-align: center;
}
</style>
